import { Routes } from '@angular/router';
import { AUTH_UI_PATH_ELEMENTS } from './core/auth/definitions/auth-ui-navigation.definitions';
import { MAIN_NAVIGATION_PATHS } from './core/router/definitions/main-navigation.definitions';
import { USER_UI_PATH_ELEMENTS } from './core/users/definitions/user-ui-navigation.definitions';
import { JointResponsibilityAgreementComponent } from './views/joint-responsibility-agreement-ui/components/joint-responsibility-agreement.component';
import { LegalNoticeComponent } from './views/legal-notice-ui/components/legal-notice.component';
import { PrivacyPolicyComponent } from './views/privacy-policy-ui/compopnents/privacy-policy.component';

export const appRoutes: Routes = [
  {
    path: AUTH_UI_PATH_ELEMENTS.rootElement,
    loadChildren: () => import('./views/auth-ui/auth-ui.module').then((m) => m.AuthUiModule),
  },
  {
    path: 'admin',
    loadChildren: () => import('./views/admin-ui/admin-ui.module').then((m) => m.AdminUiModule),
  },
  {
    path: 'develop',
    loadChildren: () =>
      import('./views/developer-mode-ui/developer-mode-ui.module').then(
        (m) => m.DeveloperModeUiModule
      ),
  },
  {
    path: USER_UI_PATH_ELEMENTS.rootElement,
    loadChildren: () => import('./views/users-ui/users-ui.module').then((m) => m.UsersUiModule),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./views/profile-ui/profile-ui.module').then((m) => m.ProfileUiModule),
  },
  {
    path: `${MAIN_NAVIGATION_PATHS.legalNotice}`,
    component: LegalNoticeComponent,
  },
  {
    path: `${MAIN_NAVIGATION_PATHS.privacyPolicy}`,
    component: PrivacyPolicyComponent,
  },
  {
    path: `${MAIN_NAVIGATION_PATHS.jointResponsibilityAgreement}`,
    component: JointResponsibilityAgreementComponent,
  },
  {
    path: '**',
    redirectTo: `/${AUTH_UI_PATH_ELEMENTS.rootElement}/${AUTH_UI_PATH_ELEMENTS.root.loginElement}`,
  },
];
